import React from 'react';
import { Typography, Box, Tooltip } from '@mui/material';

interface VersionInfoProps {
  sx?: any;
  position?: 'center' | 'bottom-right';
}

const VersionInfo: React.FC<VersionInfoProps> = ({ sx, position = 'bottom-right' }) => {
  // Get version info from environment variables
  const buildTime = process.env.REACT_APP_BUILD_TIME || 'Development';
  const buildVersion = process.env.REACT_APP_BUILD_VERSION || 'local';
  
  // Parse UTC time from build time if available
  let utcTime = '';
  let eastTime = '';
  
  if (buildTime !== 'Development') {
    try {
      // Try to parse the date - this assumes the build time is in UTC
      const utcDate = new Date(buildTime + ' UTC');
      
      // Format UTC time
      utcTime = utcDate.toISOString().replace('T', ' ').substring(0, 19) + ' UTC';
      
      // Format US East Coast time (UTC-4 or UTC-5 depending on DST)
      const eastOptions = { timeZone: 'America/New_York', timeZoneName: 'short' as const };
      eastTime = utcDate.toLocaleString('en-US', eastOptions);
    } catch (e) {
      console.error('Error parsing build time:', e);
      utcTime = buildTime + ' UTC';
      eastTime = buildTime + ' ET';
    }
  }
  
  const positionStyles = position === 'bottom-right' ? {
    position: 'fixed',
    bottom: '8px',
    right: '8px',
    zIndex: 1000,
  } : {};
  
  return (
    <Box sx={{ ...positionStyles, ...sx }}>
      <Tooltip 
        title={`Build: ${buildVersion}\nUTC: ${utcTime}\nET: ${eastTime}`}
        placement="top"
        arrow
      >
        <Typography 
          variant="caption" 
          sx={{ 
            opacity: 0.3, 
            fontSize: '0.65rem',
            userSelect: 'none',
            '&:hover': {
              opacity: 0.7
            }
          }}
        >
          v{buildVersion}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default VersionInfo;
